import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import "react-notifications/lib/notifications.css";
import "react-toastify/dist/ReactToastify.css";
import ToasterContainer from "./component/Common/ToasterContainer";
import App from "./App";
import "themes/scss/main.scss";
import "themes/scss/index.scss";
import "../src/index.css";
import TagManager from "react-gtm-module";
import clevertap from "clevertap-web-sdk";

ReactDOM.render(
  <Provider store={store}>
    <ToasterContainer />
    <App />
  </Provider>,
  document.getElementById("root")
);

if (process.env.REACT_APP_GTM_ID) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
  };
  TagManager.initialize(tagManagerArgs);
}

// Initialize CleverTap
if (process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID && process.env.REACT_APP_CLEVERTAP_REGION) {
  try {
    // REAL initialization

    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init(
      process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID,
      process.env.REACT_APP_CLEVERTAP_REGION
    );
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(
    //     (position) => {
    //       clevertap.getLocation(position.coords.latitude, position.coords.longitude);
    //     },
    //     (error) => {
    //       console.warn("[CleverTap] Geolocation unavailable:", error.message);
    //     }
    //   );
    // }
    clevertap.notifications.push({
      titleText: "Would you like to receive Push Notifications?",
      bodyText:
        "We promise to only send you relevant content and give you updates on your transactions",
      okButtonText: "Sign me up!",
      rejectButtonText: "No thanks",
      okButtonColor: "#F28046",
      askAgainTimeInSeconds: 900,
      serviceWorkerPath: "/clevertap_sw.js", // path to your custom service worker file
    });
  } catch (error) {
    console.error("CleverTap initialization failed:", error);
  }
}

if (process.env.REACT_APP_ENV === "staging") {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow";
  document.head.appendChild(meta);
}
